import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import { CSSTransition } from 'react-transition-group';
import * as colors from '@atlaskit/theme/colors';
import { ProgressTrackerListItem, ProgressTrackerStageBar, ProgressTrackerStageContainer, ProgressTrackerStageMarker, ProgressTrackerStageTitle } from './styled';
var semibold = '600';
var regular = '400';

var getMarkerColor = function getMarkerColor(status) {
  switch (status) {
    case 'unvisited':
      return colors.N70;

    case 'current':
    case 'visited':
    case 'disabled':
      return colors.B300;

    default:
      return;
  }
};

var getTextColor = function getTextColor(status) {
  switch (status) {
    case 'unvisited':
      return colors.N300;

    case 'current':
      return colors.B300;

    case 'visited':
      return colors.N800;

    case 'disabled':
      return colors.N70;

    default:
      return;
  }
};

var getFontWeight = function getFontWeight(status) {
  switch (status) {
    case 'unvisited':
      return regular;

    case 'current':
    case 'visited':
    case 'disabled':
      return semibold;

    default:
      return;
  }
};

var ProgressTrackerStage = /*#__PURE__*/function (_PureComponent) {
  _inherits(ProgressTrackerStage, _PureComponent);

  var _super = _createSuper(ProgressTrackerStage);

  function ProgressTrackerStage(props) {
    var _this;

    _classCallCheck(this, ProgressTrackerStage);

    _this = _super.call(this, props);
    _this.state = {
      transitioning: false,
      oldMarkerColor: getMarkerColor(_this.props.item.status),
      oldPercentageComplete: 0
    };
    return _this;
  }

  _createClass(ProgressTrackerStage, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        transitioning: true
      }));
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps() {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        transitioning: true
      }));
    }
  }, {
    key: "shouldShowLink",
    value: function shouldShowLink() {
      return this.props.item.status === 'visited' && !this.props.item.noLink;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          item = _this$props.item,
          render = _this$props.render,
          transitionDelay = _this$props.transitionDelay,
          transitionSpeed = _this$props.transitionSpeed,
          transitionEasing = _this$props.transitionEasing;

      var onEntered = function onEntered() {
        _this2.setState({
          transitioning: false,
          oldMarkerColor: getMarkerColor(item.status),
          oldPercentageComplete: item.percentageComplete
        });
      };

      var ariaCurrent = item.status === 'current' ? 'step' : 'false';
      return /*#__PURE__*/React.createElement(ProgressTrackerListItem, {
        "aria-current": ariaCurrent
      }, /*#__PURE__*/React.createElement(ProgressTrackerStageContainer, null, /*#__PURE__*/React.createElement(CSSTransition, {
        appear: true,
        in: this.state.transitioning,
        onEntered: onEntered,
        timeout: transitionDelay + transitionSpeed,
        classNames: "fade"
      }, /*#__PURE__*/React.createElement(ProgressTrackerStageMarker, {
        oldMarkerColor: this.state.oldMarkerColor,
        color: getMarkerColor(item.status),
        transitionSpeed: transitionSpeed,
        transitionDelay: transitionDelay,
        transitionEasing: transitionEasing
      })), /*#__PURE__*/React.createElement(CSSTransition, {
        appear: true,
        in: this.state.transitioning,
        onEntered: onEntered,
        timeout: transitionDelay + transitionSpeed,
        classNames: "fade"
      }, /*#__PURE__*/React.createElement(ProgressTrackerStageBar, {
        oldPercentageComplete: this.state.oldPercentageComplete,
        percentageComplete: item.percentageComplete,
        transitionSpeed: transitionSpeed,
        transitionDelay: transitionDelay,
        transitionEasing: transitionEasing
      })), /*#__PURE__*/React.createElement(CSSTransition, {
        appear: true,
        in: this.state.transitioning,
        onEntered: onEntered,
        timeout: transitionDelay + transitionSpeed,
        classNames: "fade"
      }, /*#__PURE__*/React.createElement(ProgressTrackerStageTitle, {
        color: getTextColor(item.status),
        fontweight: getFontWeight(item.status),
        transitionSpeed: transitionSpeed,
        transitionDelay: transitionDelay
      }, this.shouldShowLink() ? render.link({
        item: item
      }) : item.label))));
    }
  }]);

  return ProgressTrackerStage;
}(PureComponent);

export { ProgressTrackerStage as default };